var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.attachList),function(item){return _c('van-cell',{key:item.attachId},[_c('a',{staticClass:"title-class",on:{"click":function($event){return _vm.preview(item)}}},[_vm._v(_vm._s(item.attachName))])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }